/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RepatriationMetadata
 */
export interface RepatriationMetadata {
    /**
     * 
     * @type {string}
     * @memberof RepatriationMetadata
     */
    clientCompanyName: string;
    /**
     * 
     * @type {string}
     * @memberof RepatriationMetadata
     */
    clientCompanyLogoUrl: string;
    /**
     * 
     * @type {string}
     * @memberof RepatriationMetadata
     */
    freelancerEmail: string;
}

/**
 * Check if a given object implements the RepatriationMetadata interface.
 */
export function instanceOfRepatriationMetadata(value: object): value is RepatriationMetadata {
    if (!('clientCompanyName' in value) || value['clientCompanyName'] === undefined) return false;
    if (!('clientCompanyLogoUrl' in value) || value['clientCompanyLogoUrl'] === undefined) return false;
    if (!('freelancerEmail' in value) || value['freelancerEmail'] === undefined) return false;
    return true;
}

export function RepatriationMetadataFromJSON(json: any): RepatriationMetadata {
    return RepatriationMetadataFromJSONTyped(json, false);
}

export function RepatriationMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepatriationMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'clientCompanyName': json['clientCompanyName'],
        'clientCompanyLogoUrl': json['clientCompanyLogoUrl'],
        'freelancerEmail': json['freelancerEmail'],
    };
}

export function RepatriationMetadataToJSON(value?: RepatriationMetadata | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientCompanyName': value['clientCompanyName'],
        'clientCompanyLogoUrl': value['clientCompanyLogoUrl'],
        'freelancerEmail': value['freelancerEmail'],
    };
}

